export default function isOverEighteen(date) {
  const day = date.split('-')[2]
  const month = date.split('-')[1]
  const year = date.split('-')[0]
  const now = parseInt(new Date().toISOString().slice(0, 10).replace(/-/g, ''))
  const dob = year * 10000 + month * 100 + day * 1

  return now - dob > 180000
}
